import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzModalModule } from 'ng-zorro-antd/modal';

import { LotNegotiationsPriceFormModalComponent } from './components/lot-negotiations-price-form-modal/lot-negotiations-price-form-modal.component';
import { LotNegotiationsPriceButtonComponent } from './lot-negotiations-price-button.component';

@NgModule({
  declarations: [LotNegotiationsPriceButtonComponent, LotNegotiationsPriceFormModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    NzButtonModule,
    NzIconModule,
    NzInputNumberModule,
    NzModalModule,
  ],
  exports: [LotNegotiationsPriceButtonComponent],
})
export class LotNegotiationsPriceButtonModule {}
